<template>
  <ApexChart type="line" :options="chartOptions" :series="series"></ApexChart>
</template>

<script>
export default {
  name: "LineChart",
  data() {
    return {
      series: [
        {
          name: "Line",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148, 200, 500, 150],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          show: false,
        },
        xaxis: {
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          labels: {
            style: {
              colors: "#838383",
              fontFamily: "Inter",
              fontWeight: 500,
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#838383",
              fontFamily: "Inter",
              fontWeight: 600,
            },
          },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// LineChart.vue?53beda76